// extracted by mini-css-extract-plugin
export default {"navColor":"var(--themeNavTextColor)","wrap":"TopButton_wrap__vQJtq"};